import React from 'react';
import { ASSETS, CONFIG } from '../data/assets';
import styles from './Tracker.module.css';

export default function Tracker({ rows, log, meta, resetTracker, clearLog }) {
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  });

  const opens    = meta.opens    || 0;
  const partials = meta.partials || 0;
  const submits  = meta.submits  || 0;

  const days = meta.firstOpen
    ? Math.floor((new Date() - new Date(meta.firstOpen)) / 86400000)
    : null;

  const lastActivity = log.length > 0
    ? (() => {
        const diff = Math.floor((new Date() - new Date(log[0].time)) / 60000);
        return diff < 1 ? 'Just now' : diff < 60 ? `${diff}m ago` : `${Math.floor(diff / 60)}h ago`;
      })()
    : '—';

  const filledCount = rows.filter(r => r.na || r.hours !== '').length;

  const TYPE_CLASS = { open: styles.ltOpen, partial: styles.ltPartial, submit: styles.ltSubmit };
  const TYPE_LABEL = { open: 'Opened', partial: 'Partial Save', submit: 'Submitted' };

  return (
    <div className={styles.tracker}>

      {/* Masthead */}
      <div className={styles.masthead}>
        <div className={styles.mastheadTop}>
          <span className={styles.pub}>Pacific Rim Capital — Internal Tracker</span>
          <span className={styles.dateStr}>{today}</span>
        </div>
        <h1 className={styles.headline}>Hours Request<br />Activity Report</h1>
        <div className={styles.deck}>
          <span>
            Live tracking for lease <strong>{CONFIG.lease}</strong> — {CONFIG.client}
          </span>
          <button className={styles.resetBtn} onClick={resetTracker}>↺ Reset Tracker</button>
        </div>
      </div>

      {/* Stat strip */}
      <div className={styles.statStrip}>
        <div className={styles.stat}><span className={`${styles.statNum} ${styles.accent}`}>{filledCount}</span><span className={styles.statLabel}>Assets Filled</span></div>
        <div className={styles.stat}><span className={styles.statNum}>{opens}</span><span className={styles.statLabel}>Times Opened</span></div>
        <div className={styles.stat}><span className={styles.statNum}>{partials}</span><span className={styles.statLabel}>Partial Saves</span></div>
        <div className={styles.stat}><span className={styles.statNum}>{submits}</span><span className={styles.statLabel}>Full Submits</span></div>
        <div className={styles.stat}><span className={styles.statNum}>{days !== null ? days : '—'}</span><span className={styles.statLabel}>Days Active</span></div>
        <div className={styles.stat}><span className={`${styles.statNum} ${styles.muted}`}>{lastActivity}</span><span className={styles.statLabel}>Last Activity</span></div>
      </div>

      {/* Two columns */}
      <div className={styles.cols}>

        {/* Asset readings */}
        <div className={styles.col}>
          <div className={styles.colHead}>
            <span>Hour Meter Readings</span>
            <span style={{ color: '#111' }}>{filledCount} / {rows.length}</span>
          </div>
          {rows.map((r, i) => {
            const asset = ASSETS[r.id];
            return (
              <div key={r.id} className={styles.assetRow}>
                <span className={styles.serial}>{asset.serial}</span>
                <span className={styles.dots} />
                {r.na
                  ? <span className={`${styles.hrs} ${styles.hrsNA}`}>N/A</span>
                  : r.hours
                  ? <span className={styles.hrs}>{parseInt(r.hours).toLocaleString()} hrs</span>
                  : <span className={`${styles.hrs} ${styles.hrsPending}`}>pending</span>
                }
              </div>
            );
          })}
        </div>

        <div className={styles.divider} />

        {/* Activity log */}
        <div className={styles.col}>
          <div className={styles.colHead}>
            <span>Activity Log</span>
            <button className={styles.clearBtn} onClick={clearLog}>Clear</button>
          </div>
          {log.length === 0 ? (
            <div className={styles.empty}>No activity recorded yet.</div>
          ) : (
            log.map((entry, i) => {
              const t = new Date(entry.time);
              const timeStr = t.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
              return (
                <div key={i} className={styles.logRow}>
                  <div className={styles.logTime}>{timeStr}</div>
                  <div>
                    <div className={`${styles.logType} ${TYPE_CLASS[entry.type] || styles.ltOpen}`}>
                      {TYPE_LABEL[entry.type] || entry.type}
                    </div>
                    <div className={styles.logDesc}>{entry.detail}</div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
